import { useSetGlobalSelection } from "@/api/section";
import { Switch as ShadSwitch } from "@/components/ui/switch";
import { useToast } from "@/hooks/use-toast";
import { useTranslation } from "react-i18next";

interface GlobalSelectionToggleProps {
  isGlobalMode: boolean;
}

export const GlobalSelectionToggle = ({
  isGlobalMode,
}: GlobalSelectionToggleProps) => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const setGlobalSelection = useSetGlobalSelection();

  const handleGlobalModeToggle = async (enabled: boolean) => {
    try {
      await setGlobalSelection.mutateAsync({
        isGlobal: enabled,
      });

      toast({
        title: t("cms.selection.globalSelection.success"),
        description: enabled
          ? t("cms.selection.globalSelection.success.enabled")
          : t("cms.selection.globalSelection.success.disabled"),
        variant: "success",
      });
    } catch (error: any) {
      toast({
        title: t("cms.selection.globalSelection.error"),
        description:
          error.message || t("cms.selection.globalSelection.error.message"),
        variant: "error",
      });
    }
  };

  return (
    <div className="flex flex-col gap-4 p-4 border rounded-lg bg-gray-50">
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-1">
          <h3 className="text-sm font-medium text-gray-900">
            {t("cms.selection.globalSelection.toggle.title")}
          </h3>
          <p className="text-xs text-gray-600">
            {t(
              "cms.selection.globalSelection.toggle.description" +
                (isGlobalMode ? ".enabled" : ".disabled"),
            )}
          </p>
          {isGlobalMode && (
            <div className="flex flex-col gap-2">
              <div className="text-xs text-gray-600">
                {t("cms.selection.globalSelection.toggle.description2.enabled")}
              </div>
            </div>
          )}
        </div>
        <ShadSwitch
          id="globalSelection"
          checked={isGlobalMode}
          onCheckedChange={handleGlobalModeToggle}
        />
      </div>
    </div>
  );
};
